import WebLayout from "../../../layout/WebLayout";

function MyTree() {
  return (
    <WebLayout pageName={"MyTree"}>
      <div className="tree">
        <ul>
          <li>
            <a className="btn btn-success" href="#">
              AMT0001
            </a>
            <ul>
              <li>
                <a className="btn btn-primary" href="#">
                  AMT0002
                </a>
                <ul>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT0005
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT0006
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT0007
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a className="btn btn-primary" href="#">
                  AMT0003
                </a>
                <ul>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT0008
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT0009
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT00010
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a className="btn btn-primary" href="#">
                  AMT0004
                </a>
                <ul>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT00011
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT00012
                    </a>
                  </li>
                  <li>
                    <a className="btn btn-primary" href="#">
                      AMT00013
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </WebLayout>
  );
}

export default MyTree;
